<template>
<CRow>
    <CCol col="12" sm="9" class="mx-auto" v-if="step === 0">
        <CRow>
            <CCol col="12" class="mb-2">
                <label class="d-block mb-0 font-lg">
                    {{ $t('campaign.goal')+' '+$t('campaign._') }}
                </label>
            </CCol>

            <CCol col="12" sm="6" class="mb-3" v-for="(goal, index) in campaignGoalOption" :key="index">
                <CCard class="h-100" :class="campaign.goal === goal.value ? 'b-a-2 border-affili-eggplant' : ''">
                    <CCardBody>
                        <FaIcon :icon="goal.icon" class="fa-2x mx-auto d-block mb-3" />
                        <span class="m-0 p-0 d-block font-weight-bold font-lg text-center mb-2">{{ goal.label }}</span>
                        <span class="m-0 p-0 d-block font-sm">{{ goal.description }}</span>
                    </CCardBody>
                    <CCardFooter class="b-a-0 pt-0">
                        <CButton @click="selectGoal(goal)" color="info" class="d-block px-5 mx-auto">انتخاب</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
    </CCol>

    <CCol col="12" sm="9" class="mx-auto" v-else-if="step === 1">
        <CRow>
            <CCol col="12">
                <BackBtn @click="backToSelectGoal()" />
            </CCol>

            <CCol col="12" class="mb-2">
                <label class="d-block mb-0 font-lg">
                    {{ $t('campaign.select_plan') }}
                </label>
            </CCol>

            <CCol col="12" sm="4" class="mb-4" v-for="(plan, index) in campaignPlanOption" :key="index" v-if="plan.goals.includes(campaign.goal)">
                <CCard class="h-100" :class="campaign.plan.key === plan.value ? 'b-a-2 border-affili-eggplant' : ''">
                    <CCardBody class="mb-0 pb-0">
                        <FaIcon :icon="plan.icon" color="black-50" class="fa-2x mx-auto d-block mb-3" />
                        <span class="m-0 p-0 d-block text-center">{{ plan.label }}</span>
                    </CCardBody>
                    <CCardFooter class="b-a-0 pt-0">
                        <CButton class="btn-block" color="info" @click="() => selectPlan(plan)">انتخاب</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
    </CCol>

    <CCol col="12" sm="9" class="mx-auto" v-else-if="step === 2">
        <CRow>
            <CCol col="12">
                <BackBtn @click="backToSelectPlan()" />
            </CCol>

            <CCol col="12" class="mb-2">
                <label class="d-block mb-0 font-lg">
                    {{ $t('campaign.settings._')+' '+$t('campaign.plan') }}
                </label>
            </CCol>

            <PlanSettingsForm @submit="updatePlanSettings" :settings="$deepClone(campaign.plan.settings)" :planKey="campaign.plan.key" :goal="campaign.goal" />
        </CRow>
    </CCol>

    <CCol col="12" sm="9" class="mx-auto" v-if="step === 3">
        <CRow>
            <CCol col="12">
                <BackBtn @click="backToPlanSettings()" />
            </CCol>

            <CCol col="12" class="mb-2">
                <label class="d-block mb-0 font-lg">
                    {{ $t('campaign.settings._')+' '+$t('campaign._') }}
                </label>
            </CCol>

            <CCol col="12">
                <CampaignInfoForm @submit="updateCampaignInfo" :campaign="$deepClone(campaign)" />
            </CCol>
        </CRow>
    </CCol>

    <CCol col="12" sm="9" class="mx-auto" v-else-if="step === 4">
        <CRow>
            <CCol col="12">
                <BackBtn @click="backToCampaignInfo()" />
            </CCol>

            <CCol col="12">
                <CCard>
                    <CCardBody>
                        <Loading />
                        <Message />

                        <div class="mb-1 bg-gray-100 p-2 rounded">
                            <div class="mb-1"><span class="font-weight-bold">نام کمپین: </span>{{ campaign.name }}</div>
                            <div class="mb-1"><span class="font-weight-bold">هدف کمپین: </span>{{ goalStr(campaign.goal) }}</div>
                            <div class="mb-1"><span class="font-weight-bold">پلن انتخابی: </span>{{ planStr(campaign.plan.key) }}</div>

                            <div class="mb-1" v-if="Object.keys(campaign.plan.settings).filter(index => !['content'].includes(index)).length > 0">
                                <span class="font-weight-bold">تنظیمات پلن: </span>
                                <span v-if="[CampaignPlan.RETARGET, CampaignPlan.TOP_STORE, CampaignPlan.STORE_OF_THE_WEEK].includes(campaign.plan.key)">
                                    <ul>
                                        <li>
                                            <span>طول دوره: {{ campaign.plan.settings.period + ' ' + ( campaign.plan.settings.period_unit === 'month' ? 'ماه' : (campaign.plan.settings.period_unit === 'week' ? 'هفته' : '') ) }}</span>
                                        </li>
                                    </ul>
                                </span>
                                <ul v-else>
                                    <li v-for="(item, index) in campaign.plan.settings" :key="index" v-if="index !== 'content'">
                                        <span>{{ $t(`campaign.settings.${index}`) }}: </span>
                                        <span v-if="index === 'email_type'">{{ emailTypeStr(item) }}</span>
                                        <span v-else-if="index === 'instagram_ad_type'">{{ instagramAdTypeStr(item) }}</span>
                                        <span v-else-if="index === 'tags'">{{ item.map(tag => tag.text).join('، ') }}</span>
                                        <span v-else>{{ item }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="text-center mt-3 mb-4">
                            <span class="font-lg"><span class="font-weight-bold">هزینه اجرا:</span> {{ $commas(campaignCost) }} {{ $t('rial') }}</span>
                        </div>

                        <div class="">
                            <CButton color="primary" class="d-block mx-auto" @click="submit(campaign)">پرداخت و ایجاد کمپین</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </CCol>
</CRow>
</template>

<script>
import PlanSettingsForm from './PlanSettingsForm'
import CampaignInfoForm from './CampaignInfoForm'
import { campaignGoalOption, campaignPlanOption } from '@/common/data'
import { planStr, goalStr, emailTypeStr, instagramAdTypeStr } from './methods'
import { CampaignPlan, CampaignGoal } from '@/constants'

export default {
    name: 'Form',

    components: {
        PlanSettingsForm,
        CampaignInfoForm
    },

    props: {
        submit: {
            required: true,
            type: Function,
            default() {}
        },
        campaign: {
            default() {
                return {
                    //
                }
            },
            type: Object
        }
    },

    data() {
        return {
            step: 0,
            CampaignPlan,
            campaignGoalOption,
            campaignPlanOption,
        }
    },

    computed: {
        campaignCost() {
            const costSettings = this.campaignPlanOption.find(item => item.value === this.campaign.plan.key).cost
            const planSettings = this.campaign.plan.settings

            if ([CampaignGoal.ACTIVE_OLD_PUBLISHERS, CampaignGoal.NOTIFICATION].includes(this.campaign.goal)) {
                planSettings.max_send = 500
            }

            const costOfPlans = {
                [CampaignPlan.IN_APP]: (planSettings, costSettings) => Math.round(planSettings.max_send / costSettings.unit) * costSettings.price,
                [CampaignPlan.EMAIL]: (planSettings, costSettings) => Math.round(planSettings.max_send / costSettings.unit) * costSettings.price * (costSettings.coefficient.vals[planSettings[costSettings.coefficient.key]]),
                [CampaignPlan.SMS]: (planSettings, costSettings) => Math.round(planSettings.max_send / costSettings.unit) * costSettings.price,
                [CampaignPlan.BLOG_POST]: (planSettings, costSettings) => Math.round(planSettings.target_clicks / costSettings.unit) * costSettings.price,
                [CampaignPlan.REPORTAGE]: (planSettings, costSettings) => costSettings.unit * costSettings.price,
                [CampaignPlan.RETARGET]: (planSettings, costSettings) => Math.round(planSettings.period / costSettings.unit) * costSettings.price * (costSettings.coefficient.vals[planSettings[costSettings.coefficient.key]]),
                [CampaignPlan.TOP_STORE]: (planSettings, costSettings) =>Math.round(planSettings.period / costSettings.unit) * costSettings.price * (costSettings.coefficient.vals[planSettings[costSettings.coefficient.key]]),
                [CampaignPlan.STORE_OF_THE_WEEK]: (planSettings, costSettings) => Math.round(planSettings.period / costSettings.unit) * costSettings.price * (costSettings.coefficient.vals[planSettings[costSettings.coefficient.key]]),
                [CampaignPlan.AFFILI_TELEGRAM_CHANNEL]: (planSettings, costSettings) => costSettings.unit * costSettings.price,
                [CampaignPlan.AFFILI_INSTAGRAM_PAGE]: (planSettings, costSettings) => costSettings.unit * costSettings.price,
            }

            return costOfPlans[this.campaign.plan.key](planSettings, costSettings) // IRR
        },
    },

    methods: {
        planStr,
        goalStr,
        emailTypeStr,
        instagramAdTypeStr,
        backToCampaignInfo() {
            this.step = 3
        },
        selectGoal(goal) {
            this.step = 1
            this.campaign.goal = goal.value
            if (!this.campaign.id) {
                this.campaign.plan = {}
            }
        },
        backToSelectGoal() {
            this.step = 0
        },
        backToSelectPlan() {
            this.step = 1
        },
        selectPlan(plan) {
            const settings = this.$deepClone(plan.settings)
            Object.keys(settings).forEach(key => {
                if (this.campaign.plan && this.campaign.plan.settings && this.campaign.plan.settings[key]) {
                    settings[key] = this.campaign.plan.settings[key]
                }
            })
            this.$set(this.campaign, 'plan', {
                id: Math.floor(Math.random() * Date.now()),
                key: plan.value,
                settings: settings,
            })
            this.step = 2
        },
        updateCampaignInfo(campaignInfo) {
            this.campaign.name = campaignInfo.name
            this.campaign.description = campaignInfo.description
            this.campaign.store_id = campaignInfo.store_id
            this.step = 4
        },
        updatePlanSettings(settings) {
            this.campaign.plan.settings = settings
            this.step = 3
        },
        backToPlanSettings() {
            this.step = 2
        }
    }
}
</script>